import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { type NavItem, useMe } from '@/entities/session';
import { EmptyState } from '@/shared/ui';

/**
 * Доступ к разделу — по меню роли: пункт `nav` из `GET /admin/me` (ТЗ ACC 4.2.2.1). Раздела нет в
 * меню — «Раздел недоступен» (защита всё равно на сервере: 403/404).
 */
export function useSectionNavItem(section: string): NavItem | null {
  const me = useMe().data;
  return me?.nav.find((item) => item.key === section) ?? null;
}

/** Ключи разделов меню роли — ссылки в строках журналов и карточек ведут только туда. */
export function useNavSectionKeys(): ReadonlySet<string> {
  const nav = useMe().data?.nav ?? [];
  const signature = nav.map((item) => item.key).join(',');
  return useMemo(() => new Set(signature.split(',')), [signature]);
}

export function SectionUnavailable() {
  const { t } = useTranslation('shell');
  return (
    <div className="flex flex-col gap-14">
      <div className="overflow-hidden rounded-18 border border-line-strong bg-paper-pure">
        <EmptyState title={t('section.forbidden.title')} note={t('section.forbidden.note')} />
      </div>
    </div>
  );
}
